import Config from 'Config';

import { createApiClient } from '../api-client-factory';

import { ClientResponse } from './types';

const client = createApiClient(`${Config.accounts_api_url}/v2/clients`);

/**
 * Clients API client.
 */
export const clientsClient = {
  /**
   * Get given client details.
   */
  get: async (clientId: string, token: string) =>
    client.get<ClientResponse>(`${encodeURIComponent(clientId)}/public`, token),
};
